<template>
    <cadastro-simples-form
        endpoint="tipo-solicitacao-matricula"
        rota-base="/admin/tipo-solicitacao-matricula"
        titulo-singular="Tipo de Solicitação de Matrícula"
        :campos-extras='[]'>
    </cadastro-simples-form>
</template>

<script>
import CadastroSimplesForm from '@/components/cadastros-auxiliares/cadastro-simples-form.vue'
export default { components: { CadastroSimplesForm } }
</script>
